/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WalletTransactionCashType = "GRANT_MONEY" | "TOP_UP" | "WINNING_CASH" | "%future added value";
export type WalletTransactionTransactionType = "CREDIT" | "DEBIT" | "%future added value";
export type WalletTransactionHistoryQueryVariables = {||};
export type WalletTransactionHistoryQueryResponse = {|
  +walletTransactionsFilter: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +transactionType: WalletTransactionTransactionType,
        +amount: ?number,
        +created: any,
        +cashType: WalletTransactionCashType,
        +description: string,
      |}
    |}>
  |}
|};
export type WalletTransactionHistoryQuery = {|
  variables: WalletTransactionHistoryQueryVariables,
  response: WalletTransactionHistoryQueryResponse,
|};
*/


/*
query WalletTransactionHistoryQuery {
  walletTransactionsFilter {
    edges {
      node {
        id
        transactionType
        amount
        created
        cashType
        description
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WalletTransactionNodeConnection",
    "kind": "LinkedField",
    "name": "walletTransactionsFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletTransactionNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletTransactionNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transactionType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cashType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WalletTransactionHistoryQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WalletTransactionHistoryQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2300c65340abad5e26208c9482f21057",
    "id": null,
    "metadata": {},
    "name": "WalletTransactionHistoryQuery",
    "operationKind": "query",
    "text": "query WalletTransactionHistoryQuery {\n  walletTransactionsFilter {\n    edges {\n      node {\n        id\n        transactionType\n        amount\n        created\n        cashType\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b63e9f35a8ab6cabdcb5f786b220e79d';

module.exports = node;
